module.exports = __webpack_public_path__ + "static/media/new-overlay.30690709.png";